var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelativeSearchNew = function SvgRelativeSearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.333 22.667v6.666h-2.666v-6.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 22.667v6.666h-2.666v-6.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 22.667v6.666h-2.666v-6.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 22.667v6.666h-2.666v-6.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 22.667v6.666h-2.666v-6.666zM33.333 30.667v8h-2.666v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 30.667v8h-2.666v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 30.667v8h-2.666v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 30.667v8h-2.666v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 30.667v8h-2.666v-8zM50.667 29.333v9.334H48v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.667 29.333v9.334H48v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.667 29.333v9.334H48v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.667 29.333v9.334H48v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.667 29.333v9.334H48v-9.334zM16 29.333v9.334h-2.667v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333v9.334h-2.667v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333v9.334h-2.667v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333v9.334h-2.667v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333v9.334h-2.667v-9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.667 32H13.333v-2.667h37.334zM32 10.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.667 4a6.667 6.667 0 1 1 13.334 0 6.667 6.667 0 0 1-13.334 0M14.667 42.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.667 4a6.667 6.667 0 1 1 13.333 0 6.667 6.667 0 0 1-13.333 0M32 42.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.667 4a6.667 6.667 0 1 1 13.334 0 6.667 6.667 0 0 1-13.334 0M49.333 42.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.666 4a6.667 6.667 0 1 1 13.333 0 6.667 6.667 0 0 1-13.333 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgRelativeSearchNew as Icon };
export default __webpack_public_path__ + "static/media/49c9a1aefd802859780e55f3947c9c1d.svg";